import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "./Reveal";

const TECH_BG =
  "https://images.pexels.com/photos/97080/pexels-photo-97080.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";

export default function Technology() {
  const { t } = useLang();

  return (
    <section
      id="technology"
      data-testid="technology-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ background: "var(--sap-navy)" }}
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.08] bg-cover bg-center"
        style={{ backgroundImage: `url(${TECH_BG})` }}
      />
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
          maskImage:
            "radial-gradient(ellipse at center, rgba(0,0,0,0.7), transparent 70%)",
        }}
      />

      <div className="sap-container relative">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <Reveal className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="sap-divider-gold" />
              <span className="sap-overline">{t.technology.overline}</span>
            </div>
            <h2
              className="font-serif leading-[1.1] tracking-tight text-white"
              style={{
                fontSize: "clamp(1.9rem, 3.6vw, 3.2rem)",
                fontWeight: 400,
              }}
            >
              {t.technology.title}
            </h2>
          </Reveal>
          <Reveal className="lg:col-span-5" delay={120}>
            <p className="text-base md:text-lg leading-relaxed text-white/70">
              {t.technology.subtitle}
            </p>
          </Reveal>
        </div>

        {/* Marquee stack */}
        <Reveal>
          <div className="overflow-hidden py-8 border-y border-white/10 relative">
            <div className="sap-marquee">
              {[...t.technology.stack, ...t.technology.stack].map((s, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-6 shrink-0"
                >
                  <span
                    className="font-serif text-3xl md:text-4xl text-white/90"
                    style={{ fontWeight: 400, letterSpacing: "-0.01em" }}
                  >
                    {s}
                  </span>
                  <span
                    className="inline-block w-1.5 h-1.5 rounded-full"
                    style={{ background: "var(--sap-gold)" }}
                  />
                </span>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px mt-16 border border-white/10">
          {t.technology.stack.map((s, i) => (
            <Reveal key={i} delay={i * 40}>
              <div
                data-testid={`tech-item-${i}`}
                className="p-8 text-center bg-[color:var(--sap-navy)]/50 backdrop-blur-sm hover:bg-white/5 transition-colors"
              >
                <div
                  className="text-[11px] uppercase tracking-[0.28em] mb-3"
                  style={{ color: "var(--sap-gold)" }}
                >
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="font-serif text-lg text-white">{s}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
